function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M328.6,81.6c-0.4,0-0.4-0.4-0.8-0.8c-0.4-0.4-0.4-0.8-0.8-1.2L258.2,2.4c-0.4-0.4-1.2-0.8-1.6-1.2 c-0.4,0-0.4-0.4-0.8-0.4c-0.8-0.4-2-0.8-3.2-0.8H83.8C59,0,38.6,20.4,38.6,45.2v277.2c0,24.8,20.4,45.2,45.2,45.2h200 c24.8,0,45.2-20.4,45.2-45.2v-238C329,83.6,328.6,82.4,328.6,81.6z M260.2,27.2l44.4,50h-44.4V27.2z M313.8,322 c0,16.8-13.2,30.4-30,30.4h-200c-16.8,0-30-13.6-30-30V44.8c0-16.8,13.6-30,30-30H245v69.6c0,4,3.2,7.6,7.6,7.6h61.2V322z"
}), React.createElement("path", {
  d: "M92.6,92h66.8c4,0,7.6-3.2,7.6-7.6s-3.2-7.6-7.6-7.6H92.6c-4,0-7.6,3.2-7.6,7.6S88.6,92,92.6,92z"
}), React.createElement("path", {
  d: "M159.4,275.6H92.6c-4,0-7.6,3.2-7.6,7.6c0,4,3.2,7.6,7.6,7.6h66.8c4,0,7.6-3.2,7.6-7.6 C167,279.2,163.4,275.6,159.4,275.6z"
}), React.createElement("path", {
  d: "M85,134.8c0,4,3.2,7.6,7.6,7.6H271c4,0,7.6-3.2,7.6-7.6c0-4-3.2-7.6-7.6-7.6H92.6C88.6,127.2,85,130.4,85,134.8z"
}), React.createElement("path", {
  d: "M271,164.8H92.6c-4,0-7.6,3.2-7.6,7.6c0,4,3.2,7.6,7.6,7.6H271c4,0,7.6-3.2,7.6-7.6C278.6,168,275.4,164.8,271,164.8z"
}), React.createElement("path", {
  d: "M271,202H92.6c-4,0-7.6,3.2-7.6,7.6c0,4,3.2,7.6,7.6,7.6H271c4,0,7.6-3.2,7.6-7.6C278.6,205.2,275.4,202,271,202z"
}), React.createElement("path", {
  d: "M271,239.2H92.6c-4,0-7.6,3.2-7.6,7.6c0,4,3.2,7.6,7.6,7.6H271c4,0,7.6-3.2,7.6-7.6C278.6,242.8,275.4,239.2,271,239.2z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgFile = function SvgFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 367.6 367.6",
    style: {
      enableBackground: "new 0 0 367.6 367.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file.f252cbd4.svg";
export { ForwardRef as ReactComponent };